<template>
  <div class="smart container">
    <!-- <div class="jianbian">
      <div style="width: 1200px; margin: 0 auto">
        <img
            src="../assets/img/banner_zhnp@2x.png"
            alt=""
            class="banners_img"
        />
      </div>
    </div> -->
    <div class="banners" style="margin-top:77px">
      <!--   传统市场转型升级   -->
      <div class="upgradation_box">
        <div class="upgradation_left">
          <div class="upgradation_top">传统市场</div>
          <div class="upgradation_center">满足各类业务需求</div>
          <div class="upgradation_btn_box">
            <div class="upgradation_btn_pass">过去</div>
          </div>
          <div class="upgradation_title">出租经营模式</div>
          <div class="upgradation_content">市场以物业租赁为主, 缺少对市场人车货的有效管理手段</div>
          <div class="upgradation_title">管理系统不集成</div>
          <div class="upgradation_content">不同业务环节使用不同系统, 导致操作繁琐</div>
          <div class="upgradation_title">购买不便捷</div>
          <div class="upgradation_content">冷链物流体系成本高且难以监管</div>
          <div class="upgradation_title">电子结算难实施</div>
          <div class="upgradation_content">市场结算方式单一, 电子结算不明确</div>
        </div>
        <div class="upgradation_right">
          <div class="upgradation_top">转型升级</div>
          <div class="upgradation_center">提高市场办公效率</div>
          <div class="upgradation_btn_now">现在</div>
          <div class="upgradation_title">市场运营管理智能化</div>
          <div class="upgradation_content">批发市场转型为服务型, 市场经营规范化、数字化、智能化</div>
          <div class="upgradation_title">商户经营管理数字化</div>
          <div class="upgradation_content">覆盖各个业务环节, 协助商家完成数字化经营转型</div>
          <div class="upgradation_title">电子商务平台</div>
          <div class="upgradation_content">以市场为基础打造线上交易平台, 统一运营、统一监管、统一配送、统一仓储</div>
          <div class="upgradation_title">供应链金融服务</div>
          <div class="upgradation_content">覆盖多种金融业态, 统一收银、统一结算</div>
        </div>
      </div>
      <!--   智慧农批解决方案   -->
      <div class="wholesale_programme_title" style="padding-top: 60px;">
        <div class="wholesale_programme_title_text">
          智慧农批解决方案
          <img src="../assets/img/title3@2x.png" alt=""/>
        </div>
        <div class="zhexian"></div>
      </div>

      <div class="wholesale_text">
        <p>
          禾平数据打造的智慧农批平台，旨在为农产品批发市场管理方及商户提供一站式系统解决方案，
        </p>
        <p>
          搭建包括市场运营管理、进出场管理、园区管理、防疫及质检追溯管理、商户经营管理等功能的批发市场综合服务平台，
        </p>
        <p>为市场提供数字化管理手段，为批发商提供精细化经营工具。</p>
      </div>

      <div class="wholesale_img_box" style="padding-bottom: 48px;">
        <img class="wholesale_img" src="../assets/img/npjiejue.png" alt=""/>
      </div>

      <!--   七大产品体系支撑   -->
      <!-- <div class="wholesale_programme_title" style="margin-top: 71px">
        <div class="wholesale_programme_title_text" style="width: 240px">
          七大产品体系支撑
          <img src="../assets/img/title3@2x.png" alt=""/>
        </div>
        <div class="zhexian" style="margin-bottom: 50px"></div>
      </div>

      <div
          class="zhicheng_font"
          style="display: flex; width: 100%; margin-bottom: 50px;cursor: pointer"
          @click="toPage"
      >
        <div class="one" >
          <div>市场运营管理平台</div>
          <img src="../assets/img/s_sc.png" alt=""/>
        </div>
        <div class="two">
          <div>商户进销存平台</div>
          <img src="../assets/img/s-sh.png" alt=""/>
        </div>
        <div class="three">
          <div>支付结算系统</div>
          <img src="../assets/img/s-zf.png" alt=""/>
        </div>
        <div class="four">
          <div>物联网平台</div>
          <img src="../assets/img/s-wlw.png" alt=""/>
        </div>
        <div class="four">
          <div>无人值守地磅</div>
          <img src="../assets/img/s-wr.png" alt=""/>
        </div>
        <div class="five">
          <div>电子会员系统</div>
          <img src="../assets/img/s-dz.png" alt=""/>
        </div>

        <div class="six">
          <div>线上商城系统</div>
          <img src="../assets/img/s-sc.png" alt=""/>
        </div>
      </div> -->

      <!--  一站式市场数字化运营管理    -->
      <div class="wholesale_Administration">
        <div class="wholesale_programme_title">
          <div class="wholesale_programme_title_text" style="width: 360px">
            一站式市场数字化运营管理
            <img src="../assets/img/title3@2x.png" alt=""/>
          </div>
          <div class="zhexian"></div>
        </div>
        <div class="wholesale_Administration_box">
          <div
              class="wholesale_Administration_box_list"
              v-for="(item, index) in Administrationlist"
              :key="index"
          >
            <img :src="item.url" alt=""/>
            <p>{{ item.p1 }}</p>
            <i>{{ item.p2 }}</i>
            <i>{{ item.p3 }}</i>
          </div>
        </div>
      </div>

      <!--      <div class="wholesale_center_box">-->
      <!--        <div style="width: 1200px; display: flex; margin: 0 auto">-->
      <!--          <div class="center1_left" style="width: 600px">-->
      <!--            <p>商户进销存平台</p>-->
      <!--            <i-->
      <!--            >系统功能：<span-->
      <!--            >现场开单收银、数据安全管理、多种统计数据报表、进销存</span-->
      <!--            ></i-->
      <!--            >-->
      <!--            <i><span>检数据全面关联、数据分析提供经营决策数据</span></i>-->
      <!--          </div>-->
      <!--          <div-->
      <!--              class="center1_right"-->
      <!--              style="-->
      <!--              width: 600px;-->
      <!--              display: flex;-->
      <!--              flex-wrap: wrap;-->
      <!--              justify-content: space-between;-->
      <!--            "-->
      <!--          >-->
      <!--            <div-->
      <!--                class="center1_right_box"-->
      <!--                v-for="(item, index) in centerright"-->
      <!--                :key="index"-->
      <!--            >-->
      <!--              <img :src="item.url" alt=""/>-->
      <!--              <div style="margin-left: 16px">-->
      <!--                <p>{{ item.p1 }}</p>-->
      <!--                <i>{{ item.p2 }}</i>-->
      <!--              </div>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <!--      <div-->
      <!--          class="wholesale_center_box"-->
      <!--          style="background: #f7fbff; border-radius: 4px"-->
      <!--      >-->
      <!--        <div style="width: 1200px; display: flex; margin: 0 auto">-->
      <!--          <img-->
      <!--              style="width: 600px; height: 324px"-->
      <!--              src="../assets/img/dy_5@2x.png"-->
      <!--              alt=""-->
      <!--          />-->
      <!--          <div class="touminghua" style="width: 600px">-->
      <!--            <p>市场大数据透明可视化</p>-->
      <!--            <i-->
      <!--            >市场行情：<span-->
      <!--            >商品信息、商品排名、价格公示、行情公示、追溯公示、农残检测公示商户信息公示</span-->
      <!--            ></i-->
      <!--            >-->
      <!--            <i-->
      <!--            >市场运营：<span-->
      <!--            >市场商户数据、市场销售数据、市场业态分析及数据分析提供经营决策</span-->
      <!--            ></i-->
      <!--            >-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </div>-->

      <!--      <div class="wholesale_center_box">-->
      <!--        <div style="width: 1200px; display: flex; margin: 0 auto">-->
      <!--          <div class="zhifu">-->
      <!--            <p>支付结算系统</p>-->
      <!--            <i-->
      <!--            >系统机制：<span-->
      <!--            >聚合支付、一键扫码、支持多种支付方式、统一结算分账</span-->
      <!--            ></i-->
      <!--            >-->
      <!--            <i-->
      <!--            >系统效益：<span-->
      <!--            >支付无阻、避免二清、节省人力、提供增值服务</span-->
      <!--            ></i-->
      <!--            >-->
      <!--          </div>-->
      <!--          <img-->
      <!--              style="width: 600px; height: 301px"-->
      <!--              src="../assets/img/dy_51@2x.png"-->
      <!--              alt=""-->
      <!--          />-->
      <!--        </div>-->
      <!--      </div>-->

      <!-- 智能硬件对接 -->
      <!-- <div class="try">
        <div class="try_banner">
          <div class="agricultural_head trial" style="width: 1200px; z-index: 99">
            <p style="color: #ffffff">
              智能硬件对接<img
                class="try_title-img"
                src="../assets/img/title3@2x.png"
                alt=""
            />
            </p>
            <div style="background: #ffffff"></div>
          </div>
          <div class="try_center" @click="toPageHard">
            <a href="javascript:;">
              <img src="../assets/img/yingjian_1@2x.png" alt=""/>
              <p>智能电子秤</p>
            </a>
            <a href="javascript:;">
              <img src="../assets/img/yingjian_2@2x.png" alt=""/>
              <p>智能移动终端</p>
            </a>
            <a href="javascript:;">
              <img src="../assets/img/yingjian_3@2x.png" alt=""/>
              <p>智能水电表</p>
            </a>
            <a href="javascript:;">
              <img src="../assets/img/yingjian_4@2x.png" alt=""/>
              <p>电子巡查</p>
            </a>
            <a href="javascript:;">
              <img src="../assets/img/yingjian_5@2x.png" alt=""/>
              <p>多媒体终端</p>
            </a>
            <a href="javascript:;">
              <img src="../assets/img/yingjian_6@2x.png" alt=""/>
              <p>智能监控</p>
            </a>
            <a href="javascript:;">
              <img src="../assets/img/yingjian_7@2x.png" alt=""/>
              <p>智能灯杆屏</p>
            </a>
            <a href="javascript:;">
              <img src="../assets/img/yingjian_8@2x.png" alt=""/>
              <p>停车场系统</p>
            </a>
          </div>
        </div>
      </div> -->

      <!--   成功案例   -->
      <!-- <success-case></success-case> -->
      <!-- 七大产品体系支撑 -->
      <wholesale-programme></wholesale-programme>
    </div>
  </div>
</template>

<script>
import SuccessCase from "@/components/solution/successCase";
import wholesaleProgramme from "@/components/solution/wholesaleProgramme";

export default {
  components: {
    SuccessCase,
    wholesaleProgramme
  },
  data() {
    return {
      Administrationlist: [
        {
          url: require("../assets/img/yz_1@2x.png"),
          p1: "资产租聘",
          p2: "市场资源租聘流程化管理",
          p3: "包括电子合同、费用账单",
        },
        {
          url: require("../assets/img/yz_2@2x.png"),
          p1: "仓储冷库",
          p2: "完善的出入库流程作业管理功能",
          p3: "解决冷藏计费问题",
        },
        {
          url: require("../assets/img/yz_3@2x.png"),
          p1: "收费管理",
          p2: "支持多种收费方式，移动收费、",
          p3: " 自主缴费，逾期催收",
        },
        {
          url: require("../assets/img/yz_4@2x.png"),
          p1: "商铺管理",
          p2: "商户信息、店铺信息数字化管理",
          p3: "掌握商户经营数据",
        },
        {
          url: require("../assets/img/yz_5@2x.png"),
          p1: "质检溯源",
          p2: "货品质检报告数字化",
          p3: "供货进场到销售出场可全程朔源",
        },
        {
          url: require("../assets/img/yz_6@2x.png"),
          p1: "进出场管理",
          p2: "智能设备无缝对接",
          p3: "实现人、车、货的智能化管理",
        },
        // {
        //   url: require("../assets/img/yz_7@2x.png"),
        //   p1: "市场服务",
        //   p2: "提供卸货、货物配送、快递",
        //   p3: "物流、报事报修等服务",
        // },
        {
          url: require("../assets/img/wuyefuwu.png"),
          p1: "市场服务",
          p2: "提供卸货、货物配送、",
          p3: "快递物流、报事报修等服务",
        },
        {
          url: require("../assets/img/yz_8@2x.png"),
          p1: "信息公示",
          p2: "数据大屏、公众号、会员小程序",
          p3: "多渠道信息推送",
        },
      ],
      centerright: [
        {
          url: require("../assets/img/dy_1@2x.png"),
          p1: "商品管理",
          p2: "商品信息准确掌握",
        },
        {
          url: require("../assets/img/dy_2@2x.png"),
          p1: "开单销售",
          p2: "在线开单快速便捷",
        },
        {
          url: require("../assets/img/dy_3@2x.png"),
          p1: "经营报表",
          p2: "经营数据清晰明了",
        },
        {
          url: require("../assets/img/dy_4@2x.png"),
          p1: "赊销支付",
          p2: "降低赊账风险系数",
        },
      ],
    };
  },
  created() {
    this.$store.commit("solutions", -1);
    this.$store.commit("solutions", 0);
  },
  methods: {
    toPage() {
      this.$router.push('/systemPlatform')
      this.$store.commit("Navigation", 4)
    },
    toPageHard() {
      this.$router.push('/hardwareProducts')
      this.$store.commit("Navigation", 5)
    },
  }
};
</script>

<style scoped>
.container {
  width: 100%;
  margin: 0 auto;
}

.container1 {
  width: 1200px;
  margin: 0 auto;
}

.jianbian {
  width: 100%;
  /* background: linear-gradient(to right #154AC3, #1B329A ); */
  background: linear-gradient(to right, #154ac3, #1b329a);
  /* background: linear-gradient(to bottom right, #154AC3 , #1B329A); */
}

.banners_img {
  width: 1200px;
  height: 599px;
  margin: 0 auto;
}

.wholesale_programme_title {
  width: 1200px;
  margin: 0 auto;
}

.wholesale_programme_title_text {
  width: 240px;
  text-align: center;
  position: relative;
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  margin: 0 auto;
  z-index: 99;
}

.wholesale_programme_title_text img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: -8px;
  right: -15px;
  z-index: -1;
}

.zhexian {
  width: 60px;
  height: 2px;
  background: #333333;
  margin: 0 auto;
  margin-top: 16px;
}

.wholesale_text {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  margin-top: 20px;
  line-height: 26px;
}

.wholesale_img {
  width: 100%;
}

.wholesale_img_box {
  margin: 0 auto;
  margin-top: 50px;
  width: 1200px;
}

.wholesale_Administration {
  width: 100%;
  padding-top: 70px;
  height: 750px;
  border-radius: 4px;
  background: #F7FBFF;
}

.wholesale_Administration_box {
  width: 1200px;
  margin: 0 auto;
  margin-top: 26px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.wholesale_Administration_box_list {
  width: 282px;
  height: 282px;
  background: #ffffff;
  box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.05);
  border-radius: 12px;
  text-align: center;
  margin-top: 24px;
}

.wholesale_Administration_box_list img {
  width: 282px;
  height: 178px;
}

.wholesale_Administration_box_list p {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  margin-bottom: 8px;
}

.wholesale_Administration_box_list i {
  display: block;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 22px;
}

.wholesale_center_box {
  width: 100%;
  height: 325px;
}

.center1_left p {
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1958c4;
  line-height: 42px;
  margin-left: 50px;
  margin-top: 106px;
  margin-bottom: 16px;
}

.wholesale_center_box span {
  font-weight: 400;
}

.center1_left i {
  display: block;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 28px;
  margin-left: 50px;
}

.center1_right_box {
  margin-top: 40px;
  display: flex;
  margin-left: 50px;
  margin-right: 10px;
}

.center1_right_box img {
  width: 100px;
  height: 100px;
}

.center1_right_box p {
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 28px;
  margin-top: 22px;
  margin-bottom: 6px;
}

.center1_right_box i {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 22px;
}

.touminghua p {
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1958c4;
  line-height: 42px;
  margin-left: 49px;
  margin-top: 74px;
  margin-bottom: 16px;
}

.touminghua i {
  display: block;
  width: 500px;
  word-break: break-all;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 28px;
  margin-left: 49px;
  margin-bottom: 8px;
}

.zhifu {
  width: 600px;
}

.zhifu p {
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1958c4;
  line-height: 42px;
  margin-left: 50px;
  margin-top: 90px;
  margin-bottom: 16px;
}

.zhifu i {
  display: block;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
  line-height: 28px;
  margin-top: 8px;
  margin-left: 50px;
}

.zhicheng_font {
  background-repeat: no-repeat;
  background-size: cover;
  text-align: center;
  line-height: 220px;
  font-size: 22px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  /* margin: 0 auto; */
  width: 100%;
  justify-content: space-between;
}

.zhicheng_font div {
  width: 320px;
  height: 220px;
  /* overflow: hidden; */
}

.zhicheng_font img {
  width: 450px;
  height: 220px;
  overflow: hidden;
  transition: 0.5s;
}

.zhicheng_font .one,
.zhicheng_font .two,
.zhicheng_font .three,
.zhicheng_font .four,
.zhicheng_font .five,
.zhicheng_font .six {
  position: relative;
  /* width: 20%; */
}

.zhicheng_font .one div {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}

.zhicheng_font .two div {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}

.zhicheng_font .three div {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}

.zhicheng_font .four div {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}

.zhicheng_font .five div {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}

.zhicheng_font .six div {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}

.zhicheng_font .one,
.zhicheng_font .two,
.zhicheng_font .three,
.zhicheng_font .four,
.zhicheng_font .five,
.zhicheng_font .six {
  display: flex;
  overflow: hidden;
  /* transition: 0.5s; */
}

.zhicheng_font .one:hover img {
  transform: scale(1.1);
}

.zhicheng_font .two:hover img {
  transform: scale(1.1);
}

.zhicheng_font .four:hover img {
  transform: scale(1.1);
}

.zhicheng_font .three:hover img {
  transform: scale(1.1);
}

.zhicheng_font .five:hover img {
  transform: scale(1.1);
}

.zhicheng_font .six:hover img {
  transform: scale(1.1);
}

.zhicheng_font .one:hover div {
  position: absolute;
  z-index: 999;
}

.zhicheng_font .two:hover div {
  position: absolute;
  z-index: 999;
}

.zhicheng_font .four:hover div {
  position: absolute;
  z-index: 999;
}

.zhicheng_font .three:hover div {
  position: absolute;
  z-index: 999;
}

.zhicheng_font .five:hover div {
  position: absolute;
  z-index: 999;
}

.zhicheng_font .six:hover div {
  position: absolute;
  z-index: 999;
}

.zhicheng_font .one:hover {
  position: relative;
}

.zhicheng_font .two:hover {
  position: relative;
}

.zhicheng_font .four:hover {
  position: relative;
}

.zhicheng_font .three:hover {
  position: relative;
}

.zhicheng_font .five:hover {
  position: relative;
}

.zhicheng_font .six:hover {
  position: relative;
}

/* .zhicheng_font  */
/* .zhicheng_font div:nth-child(1) {
  width: 17%;
  height: 5%;
  background-image: url("../assets/img/ld_1@2x.png");
  overflow: hidden;
  transition: 0.5s;
} */
/* .zhicheng_font div:nth-child(1):hover {
  background-image: url("../assets/img/ld_1@2x.png");
  overflow: hidden;
  transform: scale(1.1);
}
.zhicheng_font div:nth-child(2) {
  background-image: url("../assets/img/ld_2@2x.png");
  transition: 0.5s;
} */
/* .zhicheng_font div:nth-child(2):hover {
  background-image: url("../assets/img/ld_2@2x.png");
  transform: scale(1.1);
}
.zhicheng_font div:nth-child(3) {
  background-image: url("../assets/img/ld_3@2x.png");
  transition: 0.5s;
}
.zhicheng_font div:nth-child(3):hover {
  background-image: url("../assets/img/ld_3@2x.png");
  transform: scale(1.1);
}
.zhicheng_font div:nth-child(4) {
  background-image: url("../assets/img/ld_4@2x.png");
  transition: 0.5s;
}
.zhicheng_font div:nth-child(4):hover {
  background-image: url("../assets/img/ld_4@2x.png");
  transform: scale(1.1);
}
.zhicheng_font div:nth-child(5) {
  background-image: url("../assets/img/ld_6@2x.png");
  transition: 0.5s;
}
.zhicheng_font div:nth-child(5):hover {
  background-image: url("../assets/img/ld_6@2x.png");
  transform: scale(1.1);
}
.zhicheng_font div:nth-child(6) {
  background-image: url("../assets/img/ld_7@2x.png");
  transition: 0.5s;
}
.zhicheng_font div:nth-child(6):hover {
  background-image: url("../assets/img/ld_7@2x.png");
  transform: scale(1.1);
} */
.upgradation_box {
  display: flex;
  width: 100%;
  height: 620px;
  color: #FFFFFF;
}

.upgradation_left {
  flex: 1;
  background-image: url("../assets/img/guoqu.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: right;
  padding-top: 40px;
  justify-content: flex-end;

}

.upgradation_right {
  flex: 1;
  background-image: url("../assets/img/xianzai.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: left;
  padding-top: 40px;
  /*background-size: cover;*/
  /*background-position: center;*/
}

.upgradation_top {
  font-size: 32px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
}

.upgradation_center {
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin: 9px 4px 75px;
}

.upgradation_btn_pass {
  width: 84px;
  height: 32px;
  line-height: 32px;
  background: #D8D8D8;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #676767;
  text-align: center;
}

.upgradation_btn_box {
  display: flex;
  justify-content: flex-end;
  margin-right: 44px;
  margin-bottom: 40px;
}

.upgradation_btn_now {
  width: 84px;
  height: 32px;
  line-height: 32px;
  background: #1958C4;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  text-align: center;
  margin-left: 44px;
  margin-bottom: 40px;
}

.upgradation_title {
  font-size: 22px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  margin-right: 44px;
}

.upgradation_right .upgradation_title {
  margin-left: 44px;
}

.upgradation_content {
  font-size: 16px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  margin: 6px 44px 24px;
}

.try {
  height: 420px;
  width: 100%;
  margin: 0 auto;
  background-image: url("../assets/img/middle@2x.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #ffffff;
  /* padding-bottom: 64px; */
}

.try_banner {
  width: 1200px;

  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  position: relative;
}

.try_center {
  width: 1200px;
  height: 420px;
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
}

.try_center a {
  display: block;
  width: 160px;
  height: 229px;
  /* background-color: red; */
  padding-top: 191px;
  text-align: center;
}

.try_center a:hover {
  height: 261px;

  padding-top: 159px;
  background: rgba(0, 0, 0, 0.5);
}

.try_center a img {
  width: 100px;
  height: 100px;
  /* margin: 0 auto; */
}

.try_center a p {
  margin-top: 55px;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 28px;
}

.try_title-img {
  position: absolute;
  left: 675px !important;
}

.agricultural_head {
  text-align: center;
  padding-top: 60px;
  padding-bottom: 50px;
}

.agricultural_head p {
  font-size: 30px;
  font-weight: 600;
  color: #333333;
  position: relative;
  z-index: 9;
}

.agricultural_head i {
  font-size: 14px;
  font-weight: 600;
  color: #999999;
}

.agricultural_head div {
  width: 60px;
  height: 2px;
  background: #333333;
  margin: 16px auto;
}

.agricultural_head img {
  width: 32px;
  height: 32px;
  position: absolute;
  top: -10px;
  left: 53%;
  z-index: -1;
}
</style>
